import { darken } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { BodyRegularSemiBold } from '../../../fonts/typography/Typography';
import DotFalling from '../spinner/DotFalling';

interface FilledButtonProps {
  bgColor: string;
  children: React.ReactNode;
  disabled?: boolean;
  loading?: boolean;
  textColor?: string;
  onClick: () => void;
  className?: string;
}

const FilledButton = ({
  bgColor,
  children,
  onClick,
  textColor,
  disabled = true,
  loading = false,
  className,
}: FilledButtonProps) => {
  return (
    <FilledStyle onClick={onClick} bgColor={bgColor} disabled={disabled} className={className}>
      {!disabled && loading ? <DotFalling color={textColor} /> : children}
    </FilledStyle>
  );
};

const FilledStyle = styled.button<FilledButtonProps>`
  ${BodyRegularSemiBold}
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 40px;
  border-radius: 4px;
  padding: 10px;
  border-style: none;
  color: ${(props) => props.textColor ?? '#FFFFFF'};
  background-color: ${(props) => (props.disabled ? '#CCCCCC' : props.bgColor)};
  transition: border 0.1s ease-in, color 0.1s ease-in;
  cursor: ${(props) => (props.loading ? 'progress' : 'pointer')};
  &:hover {
    background-color: ${(props) => (props.disabled ? '#CCCCCC' : darken(0.1, props.bgColor))};
  }
`;

export default FilledButton;
